type HighlightPluginTranslations = Record<string, string>;

export const translations: [string, HighlightPluginTranslations][] = [
  [
    "zh-CN",
    {
      "Highlight": "高亮",
      "Enable highlight": "启用高亮",
      "Highlight master switch": "高亮总开关",
      "Change any setting of highlight only apply in new sessions.":
        "任何对高亮设置的修改只会应用到新会话。",
      "Change any setting of replace only apply in new sessions.":
        "任何对替换设置的修改只会应用到新会话。",
      "Highlight applied!": "高亮已应用！",
      "ON": "开",
      "Keyword": "关键字",
      "Foreground Color": "前景色",
      "Background Color": "背景色",
      "DEL": "删除",
      "RegExp": "正则",
      "Case sensitive": "区分大小写",
      "[Highlight] Something wrong when creating RegExp, please check highlight settings":
        "[高亮] 创建正则表达式时出现错误，请检查高亮配置",
      "The following regexp is not valid:\n": "下面的正则表达式有问题：\n",
      "Everything looks good.": "一切正常。",
      "Style": "样式",
      "Bold": "粗体",
      "Italic": "斜体",
      "Underline": "下划线",
      "Dim": "变暗",
      "Case": "大小写",
      "Import": "导入",
      "Drag the ON button may reorder the keyword.": "拖动开关可以对关键字排序。",
      "Drag the ON button may reorder the pattern.": "拖动开关可以对模式排序。",
      "Profile name": "配置名称",
      "Active tab is the global highlight profile.": "活动标签页是全局生效的高亮配置。",
      "Double click tab can change profile name.": "双击标签页头可以更改配置名称。",
      "Keyword on top get high priority.": "最上面的关键字优先级最高。",
      "?": "？",
      "Enable per session profile": "启用单会话高亮配置",
      "Enable per session group profile": "启用单会话分组高亮配置",
      "Enable per session type profile": "启用单会话类型高亮配置",
      "Enable global profile": "启用全局高亮配置",
      "No session selected": "未选择会话",
      "Disable Highlight": "禁用高亮",
      "Global profile is the active tab below": "全局配置是下方激活的标签页",
      "Profile": "配置",
      "Session": "会话",
      "Session Group": "会话分组",
      "Session Type": "会话类型",
      "No session group selected": "未选择会话分组",
      "No session type selected": "未选择会话类型",
      "The profile selection order is session > group > type > global.":
        "高亮配置选择顺序是：会话 > 会话分组 > 会话类型 > 全局",
      "Enable replace": "启用替换",
      "Replace master switch": "替换总开关",
      "Search Pattern": "查找模式",
      "Replace Pattern": "替换模式",
      "[Highlight] Can not change session profile due to per session profile not enabled":
        "[高亮] 无法在未启用单会话配置的情况下修改会话配置",
      "Replacement processed from top to end.": "替换是从上往下处理的。",
      'If you want to add a new line, add "\\n" to the replace pattern.':
        "如果想要添加新行，在替换模式中添加\\n即可。",
      "Disable replace in alternate screen": "在备用屏幕中禁用替换",
      "Disable highlight in alternate screen": "在备用屏幕中禁用高亮",
      "For example: vi/vim": "例如：vi/vim",
      "Extra settings": "额外设置",
      "Match group": "匹配组",
      "Styles": "样式",
      "Remark": "备注",
    },
  ],
];
